var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error404"},[_c('error',{attrs:{"code":404,"title":"哎呀，出错了！您访问的页面不存在…"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }